import styled from "styled-components";

import Text from "components/atoms/text/Text";

export const ModalContainer = styled.div`
    width: 100%;
`;

export const ModalDescText = styled(Text).attrs({
    variant: "body-md-400",
})``;
